module.exports = __webpack_public_path__ + "iconfont.8b27435e0d2f9208c6ee.woff";


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/assets/iconfont/projectIconfont/iconfont.woff?t=1483974170613
// module id = ../../../../../ng-src/assets/iconfont/projectIconfont/iconfont.woff?t=1483974170613
// module chunks = styles